export const NODE_TITLE = 'cm:title';
export const NODE_SITES_TYPE = 'st:sites';
export const NODE_SITE_TYPE = 'st:site';
export const NODE_SITE_CONTAINER_ASPECT = 'st:siteContainer';
export const REFERENCED_ASSETS = 'apollo:referencedAssets';
export const REFERENCED_DOCUMENTS = 'apollo:referencedDocuments';
export const CHECKED_OUT_ASPECT = 'cm:checkedOut';
